export const COMMON_MESSAGE = 'COMMON_MESSAGE';